import { render, staticRenderFns } from "./CreateResourceConfig.vue?vue&type=template&id=0ecf9b48&"
import script from "./CreateResourceConfig.vue?vue&type=script&lang=js&"
export * from "./CreateResourceConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports